import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Proof() {
  return <section className="py-20 px-6 bg-[#18181b]" data-id="element-282">
      <div className="max-w-3xl mx-auto" data-id="element-283">
        <FadeIn data-id="element-284">
          <div className="relative bg-zinc-950 border border-zinc-800 rounded-2xl p-8 sm:p-12 text-center" data-id="element-285">
            <QuoteIcon className="absolute top-6 left-6 w-12 h-12 text-amber-500/10" data-id="element-286" />
            <QuoteIcon className="absolute bottom-6 right-6 w-12 h-12 text-amber-500/10 rotate-180" data-id="element-287" />

            <p className="text-xl sm:text-2xl text-zinc-300 font-medium leading-relaxed relative z-10" data-id="element-288">
              "A los 7 días de aplicar el protocolo, la mayoría de los hombres
              reportan una{' '}
              <strong className="text-amber-500 font-bold" data-id="element-289">
                limpieza en la visión
              </strong>
              , mayor facilidad para mantener el contacto visual y una
              desaparición gradual de la ansiedad social que antes los
              paralizaba."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}